export class UploadUsersList {
    static readonly type = '[User] UploadUsersList';

    constructor(public file: File, public idsModules: string[]) {}
}
